import universal from 'react-universal-component';

export default universal(() => import('./WeeklyStats'));



// WEBPACK FOOTER //
// ./src/app/views/WeeklyStats/index.js